import * as React from 'react';
import {WFormConfigItemOption} from '../config/WFormConfigItemOption';
import formStyle from '../style/WForm.less';
import Select from 'react-select';


interface WFormFieldTextSelectProps extends React.ClassAttributes<any> {
    label: JSX.Element;
    name: string;
    value: string;
    required?: boolean;
    readonly?: boolean;
    bundle_value?: string;
    bundle_text?: string;
    bundle_assign?: Array<any>;
    options: Array<any>;
    disabled?: boolean;
    onValueChange(name: string, value: any): void;
    filterOptions?(options: Array<any>, key: string, data: any):  Array<any>;  // Filter-Funktion für Options
    getFormData?(): any;                                                // Funktion zum holen der Formdaten (wg. Filter)

}
interface WFormFieldTextSelectState {
    manual: boolean;
}
export class WFormFieldTextSelect extends React.Component<WFormFieldTextSelectProps, WFormFieldTextSelectState> {

    constructor(props: any) {
        super(props);
        this.onInputChange = this.onInputChange.bind(this);
        this.state = {
            manual: false
        };
    }
    onInputChange(event: any) {
            // Wert setzen
            let value = '';
            if (event.value) {   // Fürs Select
                value = event.value;
            } else
            if (event.target) { // Fürs Textfeld
                value = event.target.value;
            }
            this.props.onValueChange(this.props.name, value);
            // ggf. weitere Werte setzen
            if (this.props.bundle_assign) {
                // Zuerst das Item finden
                const fieldValue: string = this.props.bundle_value ? this.props.bundle_value : 'tid';
                const item = this.props.options.find((opt) => opt[fieldValue] === value);
                this.props.bundle_assign.forEach((assign) => {
                    this.props.onValueChange( assign.TARGET_FIELD,  item[assign.SOURCE_FIELD]);
                });

            }
        }
    componentDidMount() {
        const fieldValue: string = this.props.bundle_value ? this.props.bundle_value : 'tid';

        if (!this.props.value && this.props.options && this.props.options.length > 0) {
            this.props.onValueChange(this.props.name,  this.props.options[0][fieldValue]);
        }
        this.initMode();
    }
    initMode() {
        const options = this.props.options  ? this.props.options : [];
        const fieldValue: string = this.props.bundle_value ? this.props.bundle_value : 'tid';

        options.forEach((o: any) => o[fieldValue] = o[fieldValue] + '');
       //  console.log('TextSelectInit: ', options , fieldValue, typeof this.props.value, typeof options[0][fieldValue]);
        if (options && this.props.value && this.props.value !== '') {
            const found = options.find((opt: any) =>  opt[fieldValue] + '' === this.props.value + '');
            const manual = found ? false : true;
            this.setState({manual});
        }
    }
    render() {
        const fieldValue: string = this.props.bundle_value ? this.props.bundle_value : 'tid';
        const fieldText = this.props.bundle_text ? this.props.bundle_text : 'name';
        let options = this.props.options; // Options holen
        if (this.props.filterOptions && this.props.getFormData) { // hier Filtern, wenn alles dafür da ist
            options = this.props.filterOptions(options, this.props.name, this.props.getFormData());
        }
        // const optionsSorted = options.sort((a: any, b: any) => a[fieldText] < b[fieldText] ? -1 : 1); // Options sortieren
        const optionsSorted = options ? options : [];
        const optionsForSelect = optionsSorted.map((opt) => { // für Options react-select bauen
            return { value: opt[fieldValue], label: opt[fieldText] };
        }).sort((a: any, b: any) => a.label.toString().toUpperCase().localeCompare(b.label.toString().toUpperCase()));
        const auswahlIdx = optionsForSelect.findIndex((element: any) => element.label.toUpperCase() === 'KEINE AUSWAHL');

        if (auswahlIdx !== -1) {
            optionsForSelect.splice(auswahlIdx, 1);
        }
        const optionSelected = optionsForSelect.find((opt) => opt.value === (this.props.value ? this.props.value : 0));
        const selectStyle = {
        option: (provided: any, state: any) => {return {...provided}; },
        control: (provided: any, state: any) => {return {...provided, width: 315}; },
        };
        const disabled = this.props.readonly || this.props.disabled ? true : false;
        return (
            <div className={formStyle.fieldBox}>
                    {this.props.label}
                    <div className={formStyle.input}>
                        <div className = {formStyle.extraOption}>
                            <input
                                type = 'checkbox'
                                checked = {this.state.manual}
                                onChange = {(evt: any) => this.setState({manual: evt.target.checked})}
                                disabled = {disabled}
                            />
                            {'  Manuelle Eingabe'}
                        </div>
                        <br />
                       { !this.state.manual ?
                            <Select
                                value = {optionSelected}
                                onChange={this.onInputChange}
                                options={optionsForSelect}
                                isDisabled = {disabled}
                                styles =  {selectStyle}
                            />
                        :
                          <input
                                type = 'text'
                                hidden = {!this.state.manual}
                                value={this.props.value ? this.props.value + '' : ''}
                                disabled = {disabled}
                                onChange={ this.onInputChange }

                            />
                        }
                    </div>
            </div>
        );
    }

}
